import { Box } from '@chakra-ui/react';

import { Condition, Iteration } from 'Component/others';
import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const AllocatedStockColumn = ({ value }) => {
  return (
    <Box className={styles['allocated-stock-column__container']}>
      <Condition
        statement={value && value.length > 0}
        fallback={
          <Box className={styles['allocated-stock-column__box--item']}>
            <TextRegular className={styles['allocated-stock-column__text']}>-</TextRegular>
          </Box>
        }
      >
        <Iteration
          items={value.filter((_, index) => index < 3)}
          render={(prize) => {
            return (
              <Box className={styles['allocated-stock-column__box--item']}>
                <TextRegular className={styles['allocated-stock-column__text']}>{prize.totalStock}</TextRegular>
              </Box>
            );
          }}
        />
      </Condition>
    </Box>
  );
};

export default AllocatedStockColumn;
